import Vue from "vue";

export default {
  // CRUD for projects

  handleSizeChangeTaskBoard({ commit, dispatch }, perPage) {
    commit("perPage", perPage);
    dispatch("getProjects");
  },
  handleCurrentChangeTaskBoard({ commit, dispatch }, page) {
    commit("currentPage", page);
    dispatch("getProjects");
  },
  getProjects({ commit, state }, payload) {
    const params = {
      page: state.currentPage,
      perPage: state.perPage,
      status: payload && payload.status,
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("setProjects", response.data.results);
          commit("paginationTotal", response.data.total);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  getProjectById({ commit }, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects/${id}`)
        .then(response => {
          commit("setProject", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addProject(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/projects`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editProject(_, payload) {
    const { id, formData } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/projects/${id}`, formData)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteProject(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/projects/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Update project status
  updateProjectStatus(_, payload) {
    const { id, status } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/projects/update-project-status/${id}`, { status })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // CRUD for tasks
  getTasks({ commit, state }, payload) {
    const params = {
      page: state.currentPage,
      perPage: state.perPage,
      ...(payload && payload),
      ...(state.searchQuery != "" && { search_query: state.searchQuery }),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects/tasks`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("setTasks", response.data);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  getTaskById({ commit }, payload) {
    const { task_id, project_id } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects/tasks/${task_id}`, { params: { project_id } })
        .then(response => {
          commit("setTask", response.data);
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  addTask(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/projects/tasks`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editTask(_, payload) {
    const { id, formData } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/projects/tasks/${id}`, formData)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteTask(_, payload) {
    const { id, formData } = payload;
    const params = { ...formData };
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/projects/tasks/${id}`, { params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // Update task status
  updateTaskStatus(_, payload) {
    const { task_id, project_id, status_id } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/projects/tasks/update-task-status`, {
          task_id,
          project_id,
          status_id,
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },

  // CRUD for task statuses
  getTaskStatuses({ commit }, payload) {
    const params = {
      ...(payload && payload),
    };
    commit("tableLoading", true);
    return new Promise((resolve, reject) => {
      Vue.$http
        .get(`/hrm/projects/task-status`, { params })
        .then(response => {
          commit("tableLoading", false);
          commit("setTaskStatuses", response.data);
          resolve(response);
        })
        .catch(error => {
          commit("tableLoading", false);
          reject(error);
        });
    });
  },
  addTaskStatus(_, payload) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .post(`/hrm/projects/task-status`, payload)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editTaskStatus(_, payload) {
    const { id, formData } = payload;
    return new Promise((resolve, reject) => {
      Vue.$http
        .put(`/hrm/projects/task-status/${id}`, formData)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteTaskStatus(_, id) {
    return new Promise((resolve, reject) => {
      Vue.$http
        .delete(`/hrm/projects/task-status/${id}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
};
